module.exports = __webpack_public_path__ + "static/media/3.8cf66f26.png";